import "./user.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUsers, updateUser } from "../../redux/apiCalls";
import moment from "moment";
import styled from "styled-components";
import Table from "../../components/advancedTable";
import Select from "react-select";
import PageHeader from "../../components/pageHeader/PageHeader";

const statusOptions = [
    {
        label: "Inactive",
        value: "inactive",
    },
    {
        label: "Active",
        value: "active",
    },
    {
        label: "All",
        value: "",
    },
];

const typeOptions = [
    {
        label: "Subdealer",
        value: "staff",
    },
    {
        label: "User",
        value: "user",
    },
    {
        label: "Dealer",
        value: "outright",
    },
    {
        label: "All",
        value: "",
    },
];

const ModalContainer = styled.div`
    height: 100%;
    width: 100%;
    opacity: 0.75;
    background: black;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 100;
`;

const OverlayContainer = styled.div`
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;

const Overlay = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    color: white;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(white, 0.5);
    visibility: visible;
    z-index: 101;
    padding: 20px;
    overflow-y: auto;
    
    @media (max-width: 768px) {
        padding: 0;
        align-items: flex-start;
    }
`;

const ModalDetails = styled.div`
    background-color: rgba(white, 0.5);
    color: black;
    width: 50%;
    max-width: 800px;
    display: flex;
    z-index: 102;
    margin: auto;
    max-height: 90vh;
    
    @media (max-width: 1024px) {
        width: 80%;
    }
    
    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
        height: 100vh;
        max-height: 100vh;
        margin: 0;
    }
`;

const ModalItemContainer = styled.div`
    background-color: white;
    color: black;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    
    @media (max-width: 768px) {
        height: 100vh;
    }
`;

export default function User() {
    const dispatch = useDispatch();
    const currentUser = useSelector((state) => state.user.currentUser);
    // eslint-disable-next-line
    const [inputs, setInputs] = useState({
        status: undefined,
        type: undefined,
        limit: 20,
        page: 1,
        name: undefined,
        principle: currentUser && !currentUser.isSuperAdmin ? currentUser._id : undefined
    });
    const [user, setUser] = useState(undefined);
    const [password, setPassword] = useState(undefined);
    const [name, setName] = useState(undefined);
    const [editModalState, setEditModalState] = useState(false);
    const [usersData, setUsersData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const fetchData = async () => {

                try {
                    const result = await getUsers(dispatch, inputs);
                    setUsersData(result ? result.users : []);
                    setTotalPages(result.totalPages);
                    setIsLoaded(true);
                } catch (error) {
                    console.error("Error fetching users:", error);
                }
            }

        if (isLoaded === false) {
        fetchData();
    };
        //eslint-disable-next-line
    }, [dispatch, inputs]);

    const handleChange = (e) => {
        setUser((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleChangeAddress = (e) => {
        setUser((prev) => {
            return {
                ...prev,
                address: { ...prev.address, [e.target.name]: e.target.value },
            };
        });
    };

    const handleStatusChange = (e) => {
        setUser((prev) => {
            return { ...prev, status: e.value };
        });
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleNameChange = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, page: 1, name: e.target.value };
        });
        setName(e.target.value);
    };

    const handleInputStatus = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, page: 1, status: e.value };
        });
    };

    const handleInputType = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, page: 1, type: e.value };
        });
    };

    const handleClick = async () => {
        const updatedUser = {
            ...user,
            password: password && password.trim() !== "" ? password : undefined
        };
        updateUser(user._id, updatedUser, dispatch);
    };

    const columns = [
        {
            accessor: "name",
            Header: "Name",
            width: 200,
            sortable: false,
        },
        {
            accessor: "phoneNumber",
            Header: "Phone Number",
            width: 200,
            sortable: false,
        },
        {
            accessor: "email",
            Header: "Email",
            width: 300,
            sortable: false,
            Cell: ({ value }) => (
                <div className="">{value ? value : ""}</div>
            ),
        },
        {
            accessor: "type",
            Header: "Type",
            width: 150,
            sortable: false,
            Cell: ({ value }) => {
                let displayValue = "";
                if (value === "staff") {
                    displayValue = "Sub-dealer";
                } else if (value === "outright") {
                    displayValue = "Dealer";
                } else if (value === "user") {
                    displayValue = "User";
                } else {
                    displayValue = value;
                }
                return <div className="capitalize">{displayValue}</div>;
            },
        },
        {
            accessor: "status",
            Header: "Status",
            width: 200,
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">{value}</div>
            ),
        },
        {
            accessor: "createdAt",
            Header: "Member Since",
            width: 200,
            sortable: false,
            Cell: ({ value }) => (
                <div className="capitalize">
                    {moment(value).format("DD/MM/YYYY")}
                </div>
            ),
        },
        {
            accessor: "action",
            Header: "Action",
            width: 200,
            sortable: false,
            Cell: (params) => {
                return (
                    <div className="flex justify-start">
                        <div
                            style={{
                                textDecoration: "none",
                                color: "black",
                            }}
                            to={"/warranty/" + params.row.original._id}
                        >
                            <button
                                onClick={() => {
                                    setUser(params.row.original);
                                    setPassword(undefined);
                                    window.scrollTo(0, 0);
                                    setEditModalState(true);
                                }}
                                className="productListEdit warrantyWidth"
                            >
                                Edit
                            </button>
                        </div>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <div className="productList">
                <PageHeader 
                    title="User Management" 
                    description="Manage user accounts and permissions" 
                />
                <div className="samerow">
                    <div className="addProductItem mt-2">
                        <input
                            className="inputFilter"
                            name="name"
                            value={name}
                            type="string"
                            placeholder="Name"
                            onChange={handleNameChange}
                        />
                    </div>
                    <div className="sameRowItem marginRight">
                        <Select
                            options={typeOptions.map((type, i) => {
                                return {
                                    label: type.label,
                                    value: type.value,
                                };
                            })}
                            onChange={handleInputType}
                            placeholder="Type"
                        />
                    </div>
                    <div className="sameRowItem marginRight">
                        <Select
                            options={statusOptions.map((status, i) => {
                                return {
                                    label: status.label,
                                    value: status.value,
                                };
                            })}
                            onChange={handleInputStatus}
                            placeholder="Status"
                        />
                    </div>
                    
                </div>

                    <Table
                        data={usersData ? usersData : []}
                        columns={columns}
                        pageCount={Math.floor(totalPages / 20) + 2}
                        totalCount={totalPages}
                        updatePagination={setInputs}
                        paginationState={inputs}
                        updateLoaded={setIsLoaded}
                        hidePagination={inputs.limit === 20 ? false : true}
                    />
            </div>

            {editModalState && (
                <OverlayContainer>
                    <ModalContainer
                        onClick={() => {
                            setEditModalState(false);
                            setPassword(undefined);
                        }}
                    ></ModalContainer>
                    <Overlay>
                        <ModalDetails>
                            <ModalItemContainer>
                                <div className="modalCloseButton" onClick={() => {
                                    setEditModalState(false);
                                    setPassword(undefined);
                                }}>
                                    ✕
                                </div>
                                <div className="updateTitle">
                                    <form className="addProductForm">
                                        <div className="addProductItem">
                                            <label>Full Name</label>
                                            <input
                                                name="name"
                                                type="text"
                                                placeholder={user.name}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <label>Email</label>
                                            <input
                                                name="email"
                                                type="text"
                                                placeholder={user.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <label>Phone Number</label>
                                            <input
                                                name="phoneNumber"
                                                type="text"
                                                placeholder={user.phoneNumber}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <label>Password</label>
                                            <input
                                                name="password"
                                                type="password"
                                                placeholder={"******"}
                                                value={password || ""}
                                                onChange={handlePasswordChange}
                                            />
                                        </div>
                                       
                                        <div className="addProductItem">
                                            <label>
                                                Date of Birth (optional)
                                            </label>
                                            <input
                                                name="dob"
                                                type="date"
                                                value={
                                                    user.dob
                                                        ? moment(
                                                              user.dob
                                                          ).format("YYYY-MM-DD")
                                                        : undefined
                                                }
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <label>Address (optional)</label>
                                            <input
                                                name="lineOne"
                                                type="string"
                                                placeholder={
                                                    user.address
                                                        ? user.address.lineOne
                                                            ? user.address
                                                                  .lineOne
                                                            : ""
                                                        : ""
                                                }
                                                onChange={handleChangeAddress}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <input
                                                name="lineTwo"
                                                type="string"
                                                placeholder={
                                                    user.address
                                                        ? user.address.lineTwo
                                                            ? user.address
                                                                  .lineTwo
                                                            : ""
                                                        : ""
                                                }
                                                onChange={handleChangeAddress}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <input
                                                name="zip"
                                                type="string"
                                                placeholder={
                                                    user.address
                                                        ? user.address.zip
                                                            ? user.address.zip
                                                            : ""
                                                        : ""
                                                }
                                                onChange={handleChangeAddress}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <input
                                                name="city"
                                                type="string"
                                                placeholder={
                                                    user.address
                                                        ? user.address.city
                                                            ? user.address.city
                                                            : ""
                                                        : ""
                                                }
                                                onChange={handleChangeAddress}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <input
                                                name="country"
                                                type="string"
                                                placeholder={
                                                    user.address
                                                        ? user.address.country
                                                            ? user.address
                                                                  .country
                                                            : ""
                                                        : ""
                                                }
                                                onChange={handleChangeAddress}
                                            />
                                        </div>
                                        <div className="addProductItem">
                                            <label>Status</label>
                                            <Select
                                                options={statusOptions.filter(option => option.value !== "").map((status) => {
                                                    return {
                                                        label: status.label,
                                                        value: status.value,
                                                    };
                                                })}
                                                onChange={handleStatusChange}
                                                placeholder={user.status ? user.status : "Select Status"}
                                                defaultValue={statusOptions.find(option => option.value === user.status)}
                                            />
                                        </div>
                                        <div
                                            onClick={handleClick}
                                            className="updateProductButton"
                                        >
                                            Update User
                                        </div>
                                    </form>
                                </div>
                            </ModalItemContainer>
                        </ModalDetails>
                    </Overlay>
                </OverlayContainer>
            )}
        </>
    );
}
